import { Controller, useController } from "react-hook-form";
import DatePicker from "react-datepicker";
import {
  forwardRef,
  Button as ChakraButton,
  Flex,
  Icon,
  Text,
  Switch,
  Tooltip,
} from "@chakra-ui/react";
import {
  AiOutlineInfoCircle,
} from "react-icons/ai";

interface DatePickerInputProps {
  selectedDate: Date;
  isCustomizableDate?: boolean;
  control: any;
  name: string;
  rules: any;
  register?: any;
  startEnabled?: boolean;
  tooltipText?: string;
  label?: string;
  labelColor?: string;
  hasSwitch?: boolean;
  disabledState?: boolean;
  setDisabledState?: (data: boolean) => void;
  locale?: string;
}

export function DatePickerInput({
  selectedDate = new Date(),
  isCustomizableDate = true,
  control,
  name,
  rules,
  register,
  startEnabled,
  tooltipText,
  label,
  hasSwitch,
  disabledState,
  setDisabledState,
  locale = "ptBR",
  labelColor = "gray.400",
  ...rest
}: DatePickerInputProps) {
  const {
    field: { onBlur },
  } = useController({
    name,
    rules,
    control,
  });

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <ChakraButton
      onClick={onClick}
      ref={ref}
      {...register}
      name={name}
      w="100%"
      borderRadius="2px"
      bgColor="transparent"
      border="1px solid"
      borderColor="#C8CBD2"
      fontSize="16px"
      disabled={hasSwitch && !disabledState}
      _focus={{
        border: "1px solid",
        borderColor: "blue.200",
      }}
      _hover={{
      }}
      _disabled={{
        cursor: "not-allowed",
      }}
      color={hasSwitch && !disabledState ? "newGray.200" : "black"}
      fontWeight="500"
    >
      <Text>
        {value}
      </Text>
    </ChakraButton>
  ));
  return (
    <Flex flexDir="column" w="100%" gap="2">
        <Flex 
            align="center"
        >
            <Flex 
                align="center"
            >
                {label && (
                    <Text
                        fontSize="12px"
                        color={hasSwitch && !disabledState ? labelColor : labelColor}
                    >
                        {label}
                    </Text>
                )}
                {tooltipText && (
                    <Tooltip placement="top" hasArrow label={tooltipText}>
                        <span>
                            <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
                        </span>
                    </Tooltip>
                )}
            </Flex>
            {hasSwitch && (
                <Switch
                    isChecked={disabledState}
                    defaultChecked={startEnabled}
                    //@ts-ignore
                    onChange={() => setDisabledState(!disabledState)}
                    size="sm"
                />
            )}
        </Flex>
        <Controller
            name={name}
            control={control}
            defaultValue={selectedDate ?? new Date()}
            render={({ field }: any) => (
                <DatePicker
                    {...rest}
                    locale={locale}
                    onBlur={onBlur}
                    wrapperClassName="datePicker"
                    selected={field.value}
                    onChange={(date) => field.onChange(date)}
                    maxDate={new Date()}
                    disabled={hasSwitch && !disabledState}
                    customInput={<CustomInput />}
                    dateFormat="dd/MM/yyyy"
                />
            )}
        />
    </Flex>
  );
}
